var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag"},[_c('js-mind',{ref:"jsMind",attrs:{"values":_vm.mind,"options":_vm.options,"height":"600px","width":"200px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }